import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AboutSlider.css';

const AboutSlider = () => {
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();

  const tabs = [
    {
      id: 0,
      label: 'Who are we?',
      type: 'whoWeAre',
      headline: 'WHO WE ARE',
      primary: 'MTPRO is an international service provider company specializing in Projects Management using state-of-the-art technologies and covering all phases of the Project from initiation and concept formulation till operation regardless of the project size, scope, or complexity.',
      consultancyNarrative: 'MTPRO is made up of a team of devoted consultants with more than 25 years of experience in multidisciplinary fields, who share the same vision to provide international standard services to help companies and stakeholders fill gaps in different phases of the project in various fields, such as; Telecommunications and Information Technology, Construction, Manufacturing, Oil & Gas,…etc.',
      expertiseSummary: 'Our experienced team consists of certified consultants with expertise in Portfolio, Program, and Project Management, Telecommunications and Information Technology, Operations Research and Analysis, Project Feasibility and assessment, Project Risk Management, and Organizational Development.',
      serviceCommitment: "As a professional projects' services company, we assist our clients not only in managing new projects and providing seamless integration between engineering, procurement, implementation and commissioning activities, but also in analyzing and assessing projects under implementation to achieve business objectives. Moreover, we help our clients to enhance their project management capabilities through setting up and operating their Project Management Office (PMO) and providing adequate training, capacity-building, and outsourcing services.",
    },
    {
      id: 1,
      label: 'Our approach',
      type: 'ourApproach',
      intro: 'Considering each service as a unique case, our approach focusses mainly on:',
      focusList: [
        'Building the right Project Management Office (PMO)',
        'Selecting an appropriate Methodology',
        'Applying relevant State-of-the-Art Technology',
        'Covering the whole Management Processes',
      ],
      blocks: [
        { type: 'p', text: 'We believe that Building the right Project Management Office (PMO) is a vital element in Project Management in order to standardize the Project operations, achieve seamless integration between Project processes and facilitate the communication process among Project stakeholders. This will help provide management with a greater visibility of project performance and maximize the probability of success.' },
        { type: 'p', text: 'In general, PMO role may include a range of activities such as; Administration and Secretary work, Project planning and tracking, Technical support, Graphics support, Change Management, Training Management, Technology and Solutions Architect, Testing Management, Quality Management, Communications management, Security Management, Database Management and Project Financial Management.' },
        { type: 'subtitle', text: 'In selecting the appropriate methodology for a project, we do consider:' },
        { type: 'list', items: ['Organizational goals, values, needs, and expectations of the clients', 'Project Complexity, stakeholders, constraints, size and cost', 'Structure of the team and need for flexibility'] },
        { type: 'p', text: 'Our experts can deploy different approaches such as; predictive Waterfall with hierarchical leadership, Critical path method CPM, Critical chain project management (CCPM) and Agile project management which focuses on team collaboration that incorporates feedback as the project progresses, as well as, Lean and Six Sigma approaches which are focused on quality and eliminating waste.' },
        { type: 'p', text: 'We believe that the best alternative is to pick the various fitting elements from all the individual methodologies to create a process that could work marvelously well for the project.' },
        { type: 'p', text: 'Applying relevant State-of-the-Art Technology enhances and reorganizes project with greater synchronicity, making management process simpler, more intuitive and more easily adaptable to the ever-changing technological landscape. This will help to increase productivity within teams, while establishing better accountability for team members. Technology helps also to provide project management process with different types of informed, accurate market research data within a short timeframe and allows to better manage inventory and deploy resources optimally.' },
        { type: 'p', text: 'Our approach allows us to Cover the whole Management Processes which includes Project Integration Management, Scope management, Schedule Management, Cost Management, Quality Management, Human Resource Management, Risk Management, Procurement Management, and Stakeholder Management.' },
      ],
    },
    {
      id: 2,
      label: 'Why choose us?',
      type: 'visionMissionValues',
      vision: 'To be a world class company providing integrated innovative projects management to our clients with clear goals and positive attitude, delivering an unparalleled quality of service, with smart, innovative solutions.',
      mission: [
        'To understand the unique needs of each client and offer the most comprehensive Portfolio, Program, and Project Management services, expertise, and training using highly motivated, highly skilled team of management consultants to help our clients Improve Performance, Leverage Capabilities and Build Capacity.',
        'To serve our clients through deploying innovative business solutions that address customer challenges and aid in accelerating the achievement of their business vision.',
      ],
      values: [
        'Highest standard of ethics and professional integrity.',
        'Commitment to the utmost customer satisfaction.',
        'Recognition of human capital and its development as the most valuable asset.',
        'Stimulating work environment with motivation, effective communication and authentic leadership covenant.',
        'Continuous quality improvement and sustainability as a way of life.',
      ],
    },
    {
      id: 3,
      label: 'Who we worked with?',
      type: 'clients',
      header: 'Our Project History & Global Clients',
      intro:
        'MTPRO has a proven track record of delivering excellence across international borders, working with government entities, semi-government organizations, and private sector leaders.',
      sectors: [
        {
          name: 'IT & Telecommunications',
          companies: [
            'Arab International Optic Company',
            'ENPPI',
            'Etisalat Misr',
            'Egyptair',
            'Aviation Information Technology',
            'ETHEDCO',
            'Saudi Amoudi Group',
          ],
        },
        {
          name: 'Construction & Infrastructure',
          companies: [
            'Arab Contractors Company',
            'Suez Canal Authority',
            'Various International Residential Investment firms',
          ],
        },
        {
          name: 'Industrial & Energy',
          companies: [
            'El-Sewedy Investment & Industries Group',
            'ETHEDCO',
            'Egyptian Styrene & Polystyrene Production',
            'Ministry of Industry',
          ],
        },
        {
          name: 'International & Governmental',
          companies: [
            'UNDP (United Nations)',
            'Ministry of Defense',
            'Ministry of Supply and Foreign Trade',
            'Arab Authority for Agricultural Investment (Sudan)',
          ],
        },
      ],
      closing:
        'From the New Administrative Capital in Egypt to industrial projects in Kuwait, Saudi Arabia, and Sudan, our team has managed complex mission-critical applications and infrastructure for over 25 years.',
    },
  ];

  useEffect(() => {
    // Jump directly to specific tabs based on URL hash
    if (location.hash === '#clients') {
      setActiveTab(3); // "Who we worked with?"
    } else if (location.hash === '#whoWeAre') {
      setActiveTab(0); // "Who are we?"
    } else if (location.hash === '#whyChooseUs') {
      setActiveTab(2); // "Why choose us?"
    }
  }, [location.hash]);

  const renderTabContent = (tab) => {
    if (tab.type === 'whoWeAre') {
      return (
        <>
          <h3 className="content-card-headline">{tab.headline}</h3>
          <p className="content-paragraph">{tab.primary}</p>
          <p className="content-paragraph">{tab.consultancyNarrative}</p>
          <p className="content-paragraph">{tab.expertiseSummary}</p>
          <p className="content-paragraph">{tab.serviceCommitment}</p>
        </>
      );
    }
    if (tab.type === 'ourApproach') {
      return (
        <>
          <p className="content-paragraph">{tab.intro}</p>
          <ul className="content-values-list">
            {tab.focusList.map((item, index) => (
              <li key={index} className="content-values-item">
                <span className="content-values-check" aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          {tab.blocks.map((block, index) => {
            if (block.type === 'p') {
              return <p key={index} className="content-paragraph">{block.text}</p>;
            }
            if (block.type === 'subtitle') {
              return <h4 key={index} className="content-block-title content-approach-subtitle">{block.text}</h4>;
            }
            if (block.type === 'list') {
              return (
                <ul key={index} className="content-values-list content-approach-list">
                  {block.items.map((item, i) => (
                    <li key={i} className="content-values-item">
                      <span className="content-values-check" aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              );
            }
            return null;
          })}
        </>
      );
    }
    if (tab.type === 'visionMissionValues') {
      return (
        <>
          <div className="content-vision-mission-block">
            <h4 className="content-block-title">Our Vision</h4>
            <p className="content-paragraph">{tab.vision}</p>
          </div>
          <div className="content-vision-mission-block">
            <h4 className="content-block-title">Our Mission</h4>
            <div className="content-mission-paras">
              {Array.isArray(tab.mission) ? tab.mission.map((para, i) => (
                <p key={i} className="content-paragraph">{para}</p>
              )) : <p className="content-paragraph">{tab.mission}</p>}
            </div>
          </div>
          <div className="content-values-block">
            <h4 className="content-block-title">Core Values</h4>
            <ul className="content-values-list">
              {tab.values.map((item, index) => (
                <li key={index} className="content-values-item">
                  <span className="content-values-check" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </>
      );
    }
    if (tab.type === 'clients') {
      return (
        <>
          <h3 className="content-card-headline">{tab.header}</h3>
          <p className="content-paragraph">{tab.intro}</p>

          <div className="clients-grid">
            {tab.sectors.map((sector, index) => (
              <div key={index} className="clients-column">
                <h4 className="clients-sector-title">{sector.name}</h4>
                <ul className="clients-list">
                  {sector.companies.map((company, i) => (
                    <li key={i} className="clients-list-item">
                      <span className="clients-bullet" aria-hidden="true" />
                      <span>{company}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <p className="content-paragraph">{tab.closing}</p>
        </>
      );
    }
    return null;
  };

  return (
    <section className="about-slider-section">
      <div className="about-container">
        <div className="about-header">
          <span className="about-tag">ABOUT US</span>
          <h2 className="about-title">Learn more about MTPRO</h2>
        </div>

        <div className="tabs-container">
          <div className="tabs-list">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="content-wrapper">
            {tabs.map((tab) => (
              <div
                key={tab.id}
                className={`content-slide ${activeTab === tab.id ? 'active' : ''}`}
              >
                <div className="content-card">
                  {renderTabContent(tab)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSlider;
